import { css } from '@lastbrand/web-ui-styled-system/css'

// mweb sticky-hover guard: the library chip recipe styles `:hover` unguarded, and touch
// devices emulate hover on tap — it persists until the next tap elsewhere, leaving a
// just-selected chip in its grey hover fill instead of the black selected fill. On
// no-hover pointers, pin the hover tones back to the resting/selected values; `!` beats
// the recipe's equal-specificity hover rules regardless of stylesheet order.
export const chipCss = css.raw({
  '@media (hover: none)': {
    _hover: {
      bg: 'white!',
      borderColor: 'lightgray!',
    },
    '&[data-state="on"]:is(:hover, [data-hover])': {
      bg: 'black!',
      borderColor: 'black!',
    },
  },
})

// Legacy `.label__leavingSoonOutOfStock` ported onto the library SelectChip (which owns its
// own padding/border/selected styles): muted text + the diagonal strikethrough `::before`.
// `position: relative` anchors the overlay — the chip recipe doesn't set it.
export const outOfStockChipCss = css.raw(chipCss, {
  position: 'relative',
  color: 'mediumgray',
  _before: {
    content: '""',
    display: 'block',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background:
      'linear-gradient(to top right, transparent calc(50% - 1px), token(colors.lightgray), transparent calc(50% + 1px))',
  },
})

// The chip group's own flex/gap is disabled — the wrapping option row (optionListWrapperClass +
// gap class) already owns layout, matching the ColorGroupDS route.
export const chipGroupCss = css.raw({
  display: 'contents',
})
